export default __webpack_public_path__ + "static/media/ug.54617f4a.svg";